import axios from "axios";

// Workaround for Emergent edge CORS override on custom domains
// (moveday-pro.emergent.host returns Access-Control-Allow-Origin: * + Allow-Credentials: true
//  on actual responses — browsers reject that combination per CORS spec).
// On the production custom domain, the ingress already routes /api/* to the backend
// same-origin, so we can skip the cross-origin call entirely. This is a temporary
// workaround; remove once Emergent support resolves the edge CORS behavior.
const RAW_BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const PROD_HOSTS = new Set(["movedaypro.com", "www.movedaypro.com"]);
const isProdCustomDomain =
  typeof window !== "undefined" && PROD_HOSTS.has(window.location.hostname);
export const BACKEND_URL = isProdCustomDomain ? "" : RAW_BACKEND;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Attach Bearer token fallback + CSRF sentinel header
// (SEC-002: body-less state-changing endpoints require X-Requested-With)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("hm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.headers["X-Requested-With"] = "XMLHttpRequest";
  return cfg;
});

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
